<template>
  <div id="ewebeditor">
    <iframe
      :id="cbid"
      :src="'/dist/ewebeditor/ewebeditor.htm?style=' + coolblue + '&id=' + cidb"
      width="800px"
      frameborder="0"
      scrolling="no"
      :height="eheight"
    ></iframe>
  </div>
</template>
<style scoped></style>
<script>
export default {
  data() {
    return {
      ewebeditorcon: "",
    };
  },
  props: ["cidb", "eheight", "cbid", "initDatecallback", "coolblue"],
  mounted() {
    document.getElementById(this.cbid).onload = this.initDatecallback;
  },
  created() {},
  methods: {
    getHtmleweb() {
      return document.getElementById("" + this.cbid).contentWindow.getHTML();
    },
    getHtmlewebQuestion() {
      return this.removefilterHtmlbr(
        document.getElementById("" + this.cbid).contentWindow.getHTML()
      );
    },
    removefilterHtmlbr(value) {
         let content = value
          .replace(/^(<[Bb][Rr]*?.*?\/?\s*?>)+/, "")
          .replace(/(<[Bb][Rr]*?.*?\/?\s*?>)+$/g, "");
      var deline = content.replace(
        /<span\sstyle="text-decoration-line:\sunderline[\s\S]*?>([\s\S]*?)<\/span>/gi,
        "<u>&nbsp;&nbsp;$1&nbsp;&nbsp;</u>"
      );
      return deline;
    },

    removefilterHtmlp(value) {
      // let content = value.replace(/^(\s*<p.*?>)|(<\/p>\s*)+$/gm, "");
      // let content = value.replace(/<p[\s\S]*?>|<\/p>/g, ""); //去掉所有P
      var con1 = value.replace(/<p([\s\S]*?)>/i, "<span$1>");
      var con1 = con1.replace(/<\/p>/i, "</span>");
      return con1;
    },

    setHtmleweb(val) {
      document.getElementById("" + this.cbid).contentWindow.setHTML(val);
    },

    setHtmlewebQuesTion(val) {
      setTimeout(() => {
        if (sessionStorage.getItem("isGeneral") == "true") {
          //普通管理员不去P
          document.getElementById("" + this.cbid).contentWindow.setHTML(val);
        } else {
          document
            .getElementById("" + this.cbid)
            .contentWindow.setHTML(this.removefilterHtmlp(val));
        }
      }, 1000);
    },
  },
};
</script>
